
  import { Component, Vue } from 'vue-property-decorator';
  import debounce from 'lodash/debounce';
  import { IJobModel } from '@/services/api.service';
  import * as ColorUtils from '@/utilities/color.utils';

  import toJobTypeFormatter from '@/filters/jobtype.formatter';

  @Component({
    props: {
      job: {
        type: Object as () => IJobModel,
        required: true
      },
      showExtendedInformation: Boolean
    },
    filters: {
      toJobType: toJobTypeFormatter
    }
  })
  export default class JobCard extends Vue {
    public gid: string = '';

    protected mounted() {
      this.gid = this.$props.job.gid;
    }

    get networkStyle() {
      console.log(this.$props.job);
      // const darkColor: string = this.shadeHexColor(this.$props.block.networkHexColor, -30);
      const darkColor: string = ColorUtils.lightenDarkenColor('#' + this.$props.job.network.hexColor, -80);

      const theStyle = {
        background: '#' + this.$props.job.network.hexColor,
        color: '#FFFFFF',
        border: darkColor + ' 1px solid'
      };
      console.log(theStyle);
      return theStyle;
      // return { background: this.$props.job.network.hexColor, color: darkColor, border: darkColor + ' 1px solid' };
    }
  }
